import { useMemo } from 'react';

import config from '@/config';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Loader from '@/shared-components/loader/Loader';
import GenericBottomSheet from '@/shared-components/popups/components/GenericBottomSheet';

import { getStickerId, getStickerImageId } from './utils';

import './StickerMenu.css';

export default function StickerMenu({ open, close, stickers = [], isLoading = false, onSelectSticker }) {
  const normalizedStickers = useMemo(() => {
    if (!Array.isArray(stickers)) return [];
    return stickers.filter((sticker) => Boolean(getStickerImageId(sticker)));
  }, [stickers]);

  function handleStickerClick(sticker) {
    if (!onSelectSticker) return;
    onSelectSticker(sticker);
  }

  return (
    <GenericBottomSheet open={open} close={close} className="sticker-menu-view__sheet">
      <div className="sticker-menu-view">
        <header className="sticker-menu-view__header">
          <span className="sticker-menu-view__title font-size-medium">Stickers</span>
          <XIcon className="sticker-menu-view__close" onClick={close} />
        </header>

        <div className="sticker-menu-view__content">
          {isLoading ? (
            <div className="sticker-menu-view__loader">
              <Loader thin />
            </div>
          ) : normalizedStickers.length === 0 ? (
            <p className="sticker-menu-view__empty font-size-medium">
              This channel has not created stickers yet.
            </p>
          ) : (
            <div className="sticker-menu-view__grid remove-scrollbar">
              {normalizedStickers.map((sticker) => {
                const imageId = getStickerImageId(sticker);
                const stickerId = getStickerId(sticker);

                if (!imageId || !stickerId) return null;

                return (
                  <button
                    key={stickerId}
                    type="button"
                    className="sticker-menu-view__sticker"
                    onClick={() => handleStickerClick(sticker)}
                  >
                    <img
                      src={`${config.app.imageServiceDomain}/${imageId}/w=256`}
                      alt="Channel sticker"
                      loading="lazy"
                    />
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </GenericBottomSheet>
  );
}
